/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateMaintenance = /* GraphQL */ `subscription OnCreateMaintenance(
  $id: ID
  $maintenance: Boolean
  $env: String
  $dateTime: AWSDateTime
) {
  onCreateMaintenance(
    id: $id
    maintenance: $maintenance
    env: $env
    dateTime: $dateTime
  ) {
    id
    maintenance
    env
    dateTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMaintenanceSubscriptionVariables,
  APITypes.OnCreateMaintenanceSubscription
>;
export const onUpdateMaintenance = /* GraphQL */ `subscription OnUpdateMaintenance(
  $id: ID
  $maintenance: Boolean
  $env: String
  $dateTime: AWSDateTime
) {
  onUpdateMaintenance(
    id: $id
    maintenance: $maintenance
    env: $env
    dateTime: $dateTime
  ) {
    id
    maintenance
    env
    dateTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMaintenanceSubscriptionVariables,
  APITypes.OnUpdateMaintenanceSubscription
>;
export const onDeleteMaintenance = /* GraphQL */ `subscription OnDeleteMaintenance(
  $id: ID
  $maintenance: Boolean
  $env: String
  $dateTime: AWSDateTime
) {
  onDeleteMaintenance(
    id: $id
    maintenance: $maintenance
    env: $env
    dateTime: $dateTime
  ) {
    id
    maintenance
    env
    dateTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMaintenanceSubscriptionVariables,
  APITypes.OnDeleteMaintenanceSubscription
>;
